export default class FacilitiesObject {
    constructor(id,center,facility_technology) {
      this.id=id;
      this.center = center;
      this.facility_technology=facility_technology
    }
  }